import { useState, useEffect } from 'react';
import { ISelectedOptionIds } from '../models/product-detail';
import {
    MATERIAL_HHS_OPTIONS_IDS,
    MATERIAL_OPTION_TYPE_ID,
    STANDARD_EARMOLD_TYPE,
    US,
} from '../components/common/constants';

export const useMaterialOptionsHook = (
    country: string,
    optionTypeID: number,
    earmoldCategory: string | undefined,
    selectedIdsState: ISelectedOptionIds,
    side: string,
    isEarmold: boolean | undefined
): boolean => {
    const [materialHHSMessage, setMaterialHHSMessage] = useState(false);

    const isMaterialHHSOptionSelected =
        (side !== 'L' &&
            MATERIAL_HHS_OPTIONS_IDS.some((id) =>
                selectedIdsState.rightSelectedIds.includes(id)
            )) ||
        (side !== 'R' &&
            MATERIAL_HHS_OPTIONS_IDS.some((id) =>
                selectedIdsState.leftSelectedIds.includes(id)
            ));

    useEffect(() => {
        if (
            isEarmold &&
            country === US &&
            optionTypeID === MATERIAL_OPTION_TYPE_ID &&
            earmoldCategory === STANDARD_EARMOLD_TYPE &&
            isMaterialHHSOptionSelected
        ) {
            setMaterialHHSMessage(true);
        } else {
            setMaterialHHSMessage(false);
        }
    }, [selectedIdsState, selectedIdsState]);

    return materialHHSMessage;
};
